// 运维平台专用认证 API（使用独立的请求工具）
import opsRequest from '@/utils/opsRequest';

export const opsAuthApi = {
  login(data) {
    return opsRequest.post('/auth/login', data);
  },
  register(data) {
    return opsRequest.post('/auth/register', data);
  },
  sendVerificationCode(email) {
    return opsRequest.post('/auth/send-verification-code', { email });
  }
};

